import { useState } from 'react'

const SUN_PATTERN = [
  '000010000',
  '010010010',
  '001111100',
  '001111100',
  '111111111',
  '001111100',
  '001111100',
  '010010010',
  '000010000',
]

const MOON_PATTERN = [
  '001111000',
  '011110000',
  '111100000',
  '111000000',
  '111000000',
  '111100000',
  '011110000',
  '001111000',
  '000000000',
]

function getInitialTheme() {
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light'
}

function PixelIcon({ pattern, className }) {
  return (
    <span className={`theme-pixel-icon ${className}`} aria-hidden="true">
      {pattern.join('').split('').map((pixel, index) => (
        <span key={index} className={pixel === '1' ? 'theme-pixel-bead' : 'theme-pixel-space'} />
      ))}
    </span>
  )
}

export default function ThemeToggle() {
  const [theme, setTheme] = useState(getInitialTheme)
  const isDark = theme === 'dark'

  const toggleTheme = () => {
    const next = isDark ? 'light' : 'dark'
    const root = document.documentElement
    root.classList.toggle('dark', next === 'dark')
    root.dataset.theme = next

    try {
      localStorage.setItem('doutian-theme', next)
    } catch {
      // The visual switch still works when storage is unavailable.
    }

    const themeColor = document.head.querySelector('meta[name="theme-color"]')
    if (themeColor) themeColor.setAttribute('content', next === 'dark' ? '#1B1F1D' : '#FF9AA2')
    setTheme(next)
  }

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className="theme-toggle"
      data-mode={theme}
      aria-label={isDark ? '切换到日间模式' : '切换到夜间模式'}
      title={isDark ? '日间模式' : '夜间模式'}
    >
      <PixelIcon pattern={SUN_PATTERN} className="theme-pixel-sun" />
      <PixelIcon pattern={MOON_PATTERN} className="theme-pixel-moon" />
    </button>
  )
}
